module.exports = __webpack_public_path__ + "static/media/HCMM111.cdbad61f.jpg";